var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "28px",
    viewBox: "0 0 44 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B12A94B2-2A79-479F-8F70-83157396A717") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Assets/Icons/Add-New-Card/ic_visa/Dark-&-Light-Mode",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(4.500000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,20.7030568 C35,21.4235808 34.4214876,22 33.6983471,22 L1.30165289,22 C0.578512397,22 0,21.4235808 0,20.7030568 L0,1.29694323 C0,0.576419214 0.578512397,0 1.30165289,0 L33.6983471,0 C34.4214876,0 35,0.576419214 35,1.29694323 L35,20.7030568 L35,20.7030568 Z",
    id: "Path",
    fill: "#1A1F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3057851,6.38864629 L9.40082645,15.6593886 L6.84573003,15.6593886 L4.91735537,8.26200873 C4.82093664,7.82969432 4.67630854,7.63755459 4.33884298,7.44541485 C3.76033058,7.15720524 2.79614325,6.8209607 1.97658402,6.6768559 L2.02479339,6.38864629 L6.12258953,6.38864629 C6.65289256,6.38864629 7.13498623,6.72489083 7.23140496,7.34934498 L8.24380165,12.7292576 L10.7506887,6.43668122 L13.3057851,6.43668122 L13.3057851,6.38864629 Z M23.285124,12.6331878 C23.285124,10.1834061 19.9104683,10.0393013 19.9104683,8.98253275 C19.9104683,8.64628821 20.2479339,8.31004367 20.922865,8.2139738 C21.2603306,8.16593886 22.2245179,8.11790393 23.285124,8.64628821 L23.7190083,6.6768559 C23.1404959,6.48471616 22.4173554,6.24454148 21.453168,6.24454148 C19.0909091,6.24454148 17.4035813,7.49344978 17.4035813,9.31877729 C17.4035813,10.6637555 18.6088154,11.3842795 19.5247934,11.8165939 C20.4407713,12.2489083 20.7782369,12.5371179 20.7782369,12.9694323 C20.7782369,13.5938865 20.0550964,13.8820961 19.3319559,13.8820961 C18.1267218,13.8820961 17.4035813,13.5458515 16.8732782,13.3056769 L16.4393939,15.3231441 C17.0179063,15.5633188 18.030303,15.8034934 19.0909091,15.8034934 C21.5977961,15.8034934 23.2369146,14.5545852 23.285124,12.6331878 M29.5523416,15.6593886 L31.7699725,15.6593886 L29.8415978,6.38864629 L27.768595,6.38864629 C27.2865014,6.38864629 26.9008264,6.6768559 26.7561983,7.06113537 L23.1404959,15.6593886 L25.6473829,15.6593886 L26.1294766,14.2663755 L29.214876,14.2663755 L29.5523416,15.6593886 Z M26.8526171,12.3930131 L28.1060606,8.93449782 L28.8292011,12.3930131 L26.8526171,12.3930131 Z M16.7286501,6.38864629 L14.7520661,15.6593886 L12.3415978,15.6593886 L14.3181818,6.38864629 L16.7286501,6.38864629 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripone);
export default __webpack_public_path__ + "static/media/stripone.960678bcd1cc66efcf28034b551a5eae.svg";
export { ForwardRef as ReactComponent };